import { getGetApiTenantsTenantSlugFeaturesQueryKey, useGetApiTenantsTenantSlugFeatures, type FeatureKey } from '@cdf/api-client-react';
import { useLocation } from 'react-router-dom';

import { tenantSlugFromPath } from '@/features/tenancy/urls';
import { featureAvailable } from '@/features/tenancy/feature-ui';

/** Generated query key is scoped by entity slug inside the account/entity cache boundary. */
export function useEntityFeatures() {
  const { pathname } = useLocation();
  const tenantSlug = tenantSlugFromPath(pathname);
  const query = useGetApiTenantsTenantSlugFeatures(tenantSlug ?? '', {
    query: { queryKey: getGetApiTenantsTenantSlugFeaturesQueryKey(tenantSlug ?? ''), enabled: Boolean(tenantSlug), staleTime: 0 }
  });
  return {
    tenantSlug,
    ...query,
    isEnabled: (key: FeatureKey) => featureAvailable(query.data?.items, key)
  };
}
